import React, { useState } from 'react';
import OtpField from '../../components/featured/OtpField/OtpField';
import ResetPasswordForm from '../../components/featured/ResetPassword/ResetPasswordForm';
import ResetPasswordConfirm from '../../components/featured/ResetPasswordConfirm/ResetPasswordConfirm';

const ResetPassword = () => {
  const user = sessionStorage.getItem('reset-user') || '';
  const stage = sessionStorage.getItem('next') || 'otp';
  const [next, setNext] = useState(stage);
  const [otp, setOtp] = React.useState('');

  const handleNext = () => {
    sessionStorage.setItem('next', 'password');
    setNext('password');
  };

  return (
    <>
      {next === 'otp' || !user ? (
        <OtpField user={user} otp={otp} setOtp={setOtp} handleNext={handleNext} />
      ) : next === 'password' ? (
        <ResetPasswordForm otp={otp} user={user} setNext={setNext} />
      ) : (
        <ResetPasswordConfirm />
      )}
    </>
  );
};

export default ResetPassword;
